'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

/**
 * SearchInput组件格式化显示
 * 如果value值与options中的选项value值对应，则展示options中对应的选项label，否则直接展示value值
 * @param {*} value
 * @param {*} state
 * @param {*} options
 * @returns
 */
function defaultValueFormatter(value, state) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if ((0, _lodash.isEmpty)(value)) {
    return '';
  }
  if (!options || options.length < 1) {
    return value;
  }

  var displayValue = value;
  for (var i = 0, len = options.length; i < len; i++) {
    if (options[i] && value === options[i].value && options[i].text) {
      displayValue = options[i].text;
      break;
    }
  }

  return displayValue;
}

exports.default = {
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];